export default __webpack_public_path__ + "static/media/portfolio-87.e58680a2.jpg";